<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h2 class="Verse-head" id="_idParaDest-6"><a id="_idTextAnchor006"></a>Angels’ Wings</h2>
<p class="Verse-new">Like a coming death, </p>
<p class="Verse-main">waves of tiredness</p>
<p class="Verse-main">sweep though mind, body, soul.</p>
<p class="Verse-main">Emptiness? Burn-out? </p>
<p class="Verse-main">Breakdown? </p>
<p class="Verse-main">A river that’s run</p>
<p class="Verse-main">dry?</p>
<p class="Verse-new">Bran tub of the restless mind,</p>
<p class="Verse-main">unlucky dip!</p>
<p class="Verse-main">Non-stop worthies that make me tick</p>
<p class="Verse-main">drain me, give little back,</p>
<p class="Verse-main">task on task, info without end,</p>
<p class="Verse-main">twittering lords of night and day –</p>
<p class="Verse-main">dumb, blind, </p>
<p class="Verse-main">don’t get what I’m at.</p>
<p class="Verse-new">Now </p>
<p class="Verse-main">the sinkhole of my fears,</p>
<p class="Verse-main">opens up</p>
<p class="Verse-main">lets slip the jackals, demons</p>
<p class="Verse-main">of the soul:</p>
<p class="Verse-new">Old-age fearful of the flow of time;</p>
<p class="Verse-last">imagined lovers that were never mine! </p>
<p class="Verse-last">Unraveling of the body </p>
<p class="Verse-last">that can’t be stopped;</p>
<p class="Verse-last">the card-house fragile ego </p>
<p class="Verse-last">craving recognition I never got. </p>
<p class="Verse-new">“All my good times they are gone, </p>
<p class="Verse-main">it’s time for movin’ on” -</p>
<p class="Verse-main">No heart, no wellspring.</p>
<p class="Verse-main">Just hurt.</p>
<p class="Verse-new">Disconnected and alone,</p>
<p class="Verse-main">I let go, </p>
<p class="Verse-main">heave the dead weight of nothings</p>
<p class="Verse-main">overboard.</p>
<p class="Verse-main">Ship now lightened journeys on.</p>
<p class="Verse-main">Sails, full and gold as angels’ wings,</p>
<p class="Verse-main">catch the winds of God. </p>
<p class="Verse-new">Provisioned with such gifts of love,</p>
<p class="Verse-main">I want for nothing, come alive.</p>
<p class="Verse-main">Abled now to give, not fearful, </p>
<p class="Verse-main">I know myself again:</p>
<p class="Verse-main">a heart wrenched open</p>
<p class="Verse-main">able to respond.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398400801_EPUB-8.vue?2d4dfa72